import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaInstagram,
  FaTiktok,
  FaDiscord as FaDiscordAlt,
  FaXTwitter,
} from "react-icons/fa6";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../services/firebase";
import LeagueRegistrationSlider from "./ui/LeagueRegistrationSlider";
import { getLatestChallengeSlug } from "../components/weeklyChallenges/customChallenge";
import { useAuth } from "../contexts/AuthContext";
import logoIcon from "../assets/images/fl-logo-icon.svg";

interface IProps {
  subscribeButton?: boolean;
}

const Footer: React.FC<IProps> = ({ subscribeButton = true }) => {
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);
  const [latestSlug, setLatestSlug] = useState("");
  const { user } = useAuth();
  const navigate = useNavigate();

  const challengeSlug = async () => {
    return await getLatestChallengeSlug();
  };
  useEffect(() => {
    async function fetchSlug() {
      try {
        const slug = await getLatestChallengeSlug();
        setLatestSlug(slug || "");
      } catch (err) {
        console.error("Failed to fetch slug:", err);
      }
    }
    fetchSlug();
  }, []);

  return (
    <footer className="siteFooter">
      <div className="wrapper">
        <div className="footerTopContent">
          <div className="footerLeft">
            <h2>
              <span>Stay in the loop</span>
              <img src={logoIcon} alt="FL Logo" />
            </h2>
            <p>
              Sign up for the{" "}
              <span className="highlightedTxt">Fantasy Loser newsletter</span>{" "}
              to get fresh challenges, punishment recaps, and insider updates as
              we grow.
            </p>
            {subscribeButton && (
              <button
                onClick={() =>
                  // setIsRegistrationOpen(true)
                  navigate("/join")
                }
                className="btnStyle"
              >
                Subscribe to Our Newsletter
              </button>
            )}
          </div>
          <div className="footerRight">
            <ul>
              <li>
                <Link to="/punishments">Punishments</Link>
              </li>
              <li>
                <Link to={`/draft-ideas`}>Draft Ideas</Link>
              </li>
              <li>
                <Link to={`/challenges/${latestSlug}`}>Challenges</Link>
              </li>
              <li>
                <Link target="_blank" to="https://shop.fantasyloser.com">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
            </ul>
            <div className="privacyMenu">
              <ul>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-of-service">Terms of Service</Link>
                </li>
              </ul>
            </div>
            <div className="socialWrap">
              <a
                href="https://www.instagram.com/fantasyloserhq/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://x.com/fantasyloserhq"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaXTwitter />
              </a>
              <a
                href="https://www.tiktok.com/@fantasyloserhq"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTiktok />
              </a>
              <a
                href="https://discord.gg/H6TADUTph2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaDiscordAlt />
              </a>
            </div>
          </div>
        </div>
        <div className="copyright">
          &copy; {new Date().getFullYear()} Fantasy Loser Interactive, Inc. All
          rights reserved.
        </div>
      </div>
      <LeagueRegistrationSlider
        isOpen={isRegistrationOpen}
        onClose={() => setIsRegistrationOpen(false)}
      />
    </footer>
  );
};

export default Footer;
